import type { CaptchaProtectedData } from "./captchaLogic.ts";

const CAPTCHA_PROTECTED_DATA: CaptchaProtectedData = {
  "question": {
    "deDe": "Was steht bei der Argumentationswippe normalerweise in der rechten unteren Ecke?",
    "enUs": "What is usually written in the bottom right corner of the Argumentationswippe?"
  },
  "cipherSalt": "ffad8cb018346c3edeb3ed005e4c1c72",
  "cipherIv": "0119e2c6fd36f99610bb257deb99c4f4",
  "cipherText": "4f1f9625241da715bf3c6462adc8950a0a5a7a3841bc57b2d9ce510758ff9aed736a83699f45fa2bfd6f78228a92837cbea09e5542bc2b5ac75d5c4b6713d1eec7d107b086aa0866a3c7af739e3ab2e4b5e4e6fa5ce3d1ffcd8b20123d99f7f20ddc0450844b95e80d0e20c76adb0b4b939f3a758846ad83d8715ec02cd3911286cf9de349cbbeba63053a"
};

export default CAPTCHA_PROTECTED_DATA;
